export const API_PATH = {
  CONTACT: 'contact'
};



// WEBPACK FOOTER //
// ./src/helper/constants.js